import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from '@angular/router';


@Injectable({
    providedIn: 'root'
})
export class IsBundledAdsAllowEditFromResolve implements Resolve<any> {

    constructor() {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {

        // ES6 Destructuring & Nesting & rename
        const { 
            units, lands, villas, related
        } = route?.data?.ads || {};  
        
        if (units?.length > 0 || lands?.length > 0 || villas?.length > 0 || related) return false
    
        return true

    }

  
}
